import React, { useState } from "react";
import BackBtn from "../../common/backBTN";

function Invite({userData, showAlert}) {
  const [activeTab, setActiveTab] = useState("overview");

  
    const referralCode = userData?.referral_code;
    const referralLink = `${window.location.origin}/referral_code?referral_code=${referralCode}`;

    const copyReferralLink = async () => {
        try {
            await navigator.clipboard.writeText(referralLink);
            alert("Referral link copied to clipboard!");
        } catch (error) {
            prompt("Copy this link:", referralLink);
        }
    };

    const shareReferralLink = () => {
        if (navigator.share) {
            navigator.share({
                title: "Join me on this platform!",
                text: `Use my referral code to sign up: ${referralCode}`,
                url: referralLink,
            }).catch(console.error);
        } else {
            alert("Sharing is not supported on this device.");
        }
	};
	
	const claimAll = () => {
		if (userData?.cash_bonus < 10) {
			showAlert("You need at least 10 to claim all.");
			return;
		}

		const token = localStorage.getItem('token');
		fetch(`${process.env.REACT_APP_API_URL}/api/cash-claim`, {
			method: "POST",
			headers: {
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({})
		}).then(response => {
			if (!response.ok) {
				return response.json().then(errData => {
					const errMsg = errData?.message || "Failed to claim bonus. Please try again.";
					throw new Error(errMsg);
				});
			}
			return response.json();
		}).then(data => {
			showAlert("Bonus Claimed successfully.");
			setTimeout(() => {
				window.location.reload();
			}, 1500);
		}).catch(error => {
			console.error("Error:", error);
			showAlert(error?.message || "An error occurred while claiming the bonus. Please try again.");
		});
	}

  const tabs = [
    { key: "overview", label: "Overview" },
    { key: "rewards", label: "Rewards" },
    { key: "incomes", label: "Incomes" },
    { key: "records", label: "Records" },
    { key: "invited", label: "Invited List" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview":
        return (
          <div className="invite-friends-container">
            <div className="container-wrap">
              <div
                className="invite-friends-goals"
                style={{
                  background:
                    "linear-gradient(118deg, rgb(151, 171, 255) 0%, rgb(18, 53, 151))",
                }}
              >
                <div className="goals-top">
                  <img
                    src="https://www.yesb1.com/mobile/mc/goals.c8ea3922.png"
                    alt="goals"
                    className="goals-img"
                  />
                  <div className="goals-title">Revenue goals</div>
                </div>
                <div className="goals-bottom has-icon">
                  <div className="amount-detail">
                    Invite friends to earn the prizes
                  </div>
                  <div className="info">
                    <svg className="am-icon am-icon-question_2bfede37 am-icon-md">
                      <use xlinkHref="#question_2bfede37" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Share section */}
              <div className="invite-friends-link">
                <div className="link-top-title">Share to your friends</div>
                <div className="share-content-wrap">
                  <div className="share-group">
                    <div className="share-btn facebook-btn" />
                    <div className="share-btn sms-btn" />
                    <div className="share-btn twitter-btn" />
                    <div className="share-btn telegram-btn" />
                    <div className="share-btn whatsapp-btn" />
                    <div className="share-btn link" />
                  </div>
                </div>
                <div className="invite-link-wrap">
                  <svg className="am-icon am-icon-share-link_b24bce29 am-icon-md">
                    <use xlinkHref="#share-link_b24bce29" />
                  </svg>
                  <div className="link-url">{referralLink}</div>
                  <div    onClick={copyReferralLink} className="link-copy">
                    <span>Copy</span>
                  </div>
                </div>
              </div>

              {/* Rewards summary */}
              <div className="invite-friends-bonus">
                <div className="default-title bonus-title">
                  Rewards Released to Date
                </div>

                {[
                  {
                    title: "Invitation Rewards",
                    amount: "5,017,357.00",
                    claimed: "7215",
                    icon: (
                      <svg viewBox="0 0 64 64" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="32" cy="32" r="30" fill="url(#inv_bg)"/>
                        <defs><linearGradient id="inv_bg" x1="0" y1="0" x2="64" y2="64"><stop stopColor="#FF6B6B"/><stop offset="1" stopColor="#FF8E53"/></linearGradient></defs>
                        <path d="M32 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-12 8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm24 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM32 32c-5.5 0-10 3.1-10 7v3h20v-3c0-3.9-4.5-7-10-7zm-12 2c-3 0-6 2-6 5v3h8v-3c0-1.8.7-3.4 1.8-4.7A13 13 0 0020 34zm24 0c-.7 0-1.4.1-2 .3 1.2 1.3 1.8 2.9 1.8 4.7v3h8v-3c0-3-3-5-6-5z" fill="#fff"/>
                        <circle cx="48" cy="16" r="8" fill="#FFD93D"/>
                        <path d="M48 12v8m-4-4h8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ),
                  },
                  {
                    title: "Achievement Rewards",
                    amount: "137,478.00",
                    claimed: "633",
                    icon: (
                      <svg viewBox="0 0 64 64" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="32" cy="32" r="30" fill="url(#ach_bg)"/>
                        <defs><linearGradient id="ach_bg" x1="0" y1="0" x2="64" y2="64"><stop stopColor="#A18CD1"/><stop offset="1" stopColor="#FBC2EB"/></linearGradient></defs>
                        <path d="M32 14l4.9 9.9 10.9 1.6-7.9 7.7 1.9 10.8L32 39l-9.8 5.1 1.9-10.8-7.9-7.7 10.9-1.6z" fill="#FFD93D" stroke="#fff" strokeWidth="1.5"/>
                        <circle cx="32" cy="28" r="6" fill="#fff" opacity=".3"/>
                      </svg>
                    ),
                  },
                  {
                    title: "Deposit Rebate",
                    amount: "219,436.20",
                    claimed: "8605",
                    icon: (
                      <svg viewBox="0 0 64 64" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="32" cy="32" r="30" fill="url(#dep_bg)"/>
                        <defs><linearGradient id="dep_bg" x1="0" y1="0" x2="64" y2="64"><stop stopColor="#43E97B"/><stop offset="1" stopColor="#38F9D7"/></linearGradient></defs>
                        <rect x="18" y="22" width="28" height="20" rx="3" fill="#fff" opacity=".9"/>
                        <rect x="18" y="26" width="28" height="6" fill="#2D9CDB"/>
                        <circle cx="32" cy="38" r="4" fill="#FFD93D" stroke="#E8A600" strokeWidth="1"/>
                        <text x="32" y="41" textAnchor="middle" fontSize="6" fontWeight="bold" fill="#E8A600">৳</text>
                        <path d="M28 16l4 6 4-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ),
                  },
                  {
                    title: "Betting Rebate",
                    amount: "613,974.73",
                    claimed: "12026",
                    icon: (
                      <svg viewBox="0 0 64 64" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="32" cy="32" r="30" fill="url(#bet_bg)"/>
                        <defs><linearGradient id="bet_bg" x1="0" y1="0" x2="64" y2="64"><stop stopColor="#4FACFE"/><stop offset="1" stopColor="#00F2FE"/></linearGradient></defs>
                        <rect x="16" y="20" width="32" height="24" rx="4" fill="#fff" opacity=".9"/>
                        <path d="M22 30h20M22 35h14" stroke="#4FACFE" strokeWidth="2" strokeLinecap="round"/>
                        <circle cx="42" cy="38" r="6" fill="#FFD93D"/>
                        <text x="42" y="41" textAnchor="middle" fontSize="7" fontWeight="bold" fill="#E8A600">%</text>
                        <path d="M30 20l2-4 2 4" stroke="#FFD93D" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ),
                  },
                ].map((bonus, i) => (
                  <div className="bonus-item" key={i}>
                    <div className="bonus-img">
                      {bonus.icon}
                    </div>
                    <div className="bonus-info">
                      <div className="info-title">{bonus.title}</div>
                      <div className="amount-balance-common info-num">
                        <span className="currency">৳</span>
                        &nbsp;
                        <span className="number-mc">{bonus.amount}</span>
                      </div>
                      <div className="info-detail">
                        <div className="detail-num">{bonus.claimed}</div>
                        <div className="detail-desc">claimed</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case "rewards":
        return (
          <div className="invite-friends-rewards">
            <div className="container-wrap">
              <div className="rewards-time">
                <div className="time-title">
                  <span className="time">No expiration</span>
                </div>
              </div>
              <div className="rewards-list">
                {[5, 10, 20, 30, 50].map((goal, i) => (
                  <div className="rewards-item disable" key={i}>
                    <div className="item-content">
                      <div className="item-title">
                        Over {goal} valid referral in total.
                      </div>
                      <div className="item-info">
                        <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                          <use xlinkHref="#coin_a9a0c66b" />
                        </svg>
                        <div className="item-num">{177 + i * 200}.00</div>
                      </div>
                    </div>
                    <div className="btn-wrap">
                      <div className="btn-info">
                        <div className="current">0</div>
                        <div className="goals">{goal}</div>
                      </div>
                      <div className="get-btn">Available</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case "incomes":
        return (
          <div className="invite-friends-income">
            <div className="container-wrap">
              <div className="income-wrap">
                <div className="income-top">
                  <div className="income-title">Today's Income:</div>
                  <div className="amount-balance-common item-num">
                    <span className="currency">৳</span>&nbsp;
                    <span className="number-mc">0.00</span>
                  </div>
                </div>
              </div>
              <div className="income-tip">
                Note: The system updates every 15 minutes.
              </div>
            </div>
          </div>
        );

      case "records":
        return (
          <div className="invite-friends-records">
            <div className="invite-search-wrap">
              <div className="select-item select-type">
                <div className="select-text">Invitation Rewards</div>
                <svg className="am-icon am-icon-arrow-down_90cec9b0 am-icon-md arrow">
                  <use xlinkHref="#arrow-down_90cec9b0" />
                </svg>
              </div>
              <div className="select-item select-date">
                <div className="flex-shrink1 filter-time-btn">
                  <a
                    role="button"
                    className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                    aria-disabled="false"
                  >
                    <svg className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs">
                      <use xlinkHref="#calendar_c4db3b67" />
                    </svg>
                    <span>10/10 - 10/10</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="search-result">
              <div className="nodata-container" style={{ height: "400px" }}>
                <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                  <use xlinkHref="#nodata_f4c19c2d" />
                </svg>
                <p>No data</p>
              </div>
            </div>
          </div>
        );

      case "invited":
        return (
          <div className="invite-friends-list">
            <div className="invite-search-wrap">
              <div className="select-item select-status">
                <div className="select-text">All</div>
                <svg className="am-icon am-icon-arrow-down_90cec9b0 am-icon-md arrow">
                  <use xlinkHref="#arrow-down_90cec9b0" />
                </svg>
              </div>
              <a
                role="button"
                className="today-btn am-button am-button-primary am-button-small am-button-inline am-button-icon"
              >
                <svg className="am-icon am-icon-check-circle-o am-icon-xxs">
                  <use xlinkHref="#check-circle-o" />
                </svg>
                <span>Today</span>
              </a>
            </div>
            <div className="nodata-container" style={{ height: "400px" }}>
              <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                <use xlinkHref="#nodata_f4c19c2d" />
              </svg>
              <p>No data</p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="invite-friends">
        <div className="invite-friends-root">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-inviteFriends mc-default-header am-navbar am-navbar-light"
            >
              <BackBtn />
              <div className="am-navbar-title">Invite Friends</div>
              <div className="am-navbar-right" />
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>

          {/* Tabs */}
          <div style={{overflow: 'auto'}} className="am-tabs am-tabs-top invite-tab">
            <div role="tablist" className="am-tabs-bar" tabIndex={0}>
              <div className="am-tabs-nav">
                {tabs.map((tab) => (
                  <div
                    key={tab.key}
                    role="tab"
                    className={`am-tabs-tab ${
                      activeTab === tab.key ? "am-tabs-tab-active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                    style={{ flexBasis: "33.33%" }}
                  >
                    <span className="am-badge">{tab.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="am-tabs-content am-tabs-content-no-animated">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invite;
